import {Injectable} from '@angular/core';
import {global} from '../../models/global';
import {Observable} from 'rxjs/Observable';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { JsonPipe } from '@angular/common';

@Injectable({
providedIn:'root'
})

export class SDAcknowledgeService{
  
    ROOT_URL: string = "";
    constructor(private http: Http) {
      let g: global = new global();
      this.ROOT_URL = g.getApiUrl();
    }
    
    GetSDAcknowledge(whLocation:any, product:any, month:any, userId :any,year :any):Observable<any>{
      let url = this.ROOT_URL + '/api/SDAcknowledge/GetSDAcknowledge';
      let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
      let body = { "userId": userId, "product": product, "month": month, "whLocation":whLocation, "Year": year};
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: body,
      })
      return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
    }

    GetAcknowledgeFilter(whLocation:any, product:any,year:any, month:any, userId :any):Observable<any>{
      let url = this.ROOT_URL + '/api/SDAcknowledge/GetAcknowledgeFilter';
      let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
      let body = { "userId": userId, "product": product,"year":year ,"month": month, "whLocation":whLocation};
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: body,
      })
      return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
    }

    SaveSDAcknowledge(data: any, userId: any): Observable<any> {
      let body = { "dispatchList": data, "userId": userId};
      let url = this.ROOT_URL + '/api/SDAcknowledge/SaveSDAcknowledge';
  
      let headers = new Headers({
        'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token')
        , 'UserId': localStorage.getItem('dsu_userId'), 'RoleCode': localStorage.getItem('dsu_roleCode')
      });
  
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: body,
      })
      return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
          return res.json();
        });
    }

    UpdateStockIn(data: any): Observable<any> {
      let body = { "model": data};
      let url = this.ROOT_URL + '/api/SDAcknowledge/UpdateStockIn';
  
      let headers = new Headers({
        'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token')
        , 'UserId': localStorage.getItem('dsu_userId'), 'RoleCode': localStorage.getItem('dsu_roleCode')
      });
  
      let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: JSON.stringify(data),
      })
      return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
          return res.json();
        });
    }
}